import React from 'react'
import { Table, Tag } from 'antd'
import { CheckCircleOutlined, WarningOutlined, EditOutlined } from '@ant-design/icons'
import { connect } from 'react-redux'
import { useFetchOverruleReasoningsQuery } from '../../../../../store/apis/overrule-reasoning.api'
import { isNil } from 'lodash'
import MetTag from './MetTag'

const FileCriteriaReasoningTable = ({ assignment, patternId, criteria, loading, token, layerId, fileId }) => {
    const { data: overruleReasonings = { items: [] }, isFetching: isLoadingOverrules } = useFetchOverruleReasoningsQuery(
        { token, layerId, motifId: patternId },
        { skip: isNil(patternId) }
    )

    const someCriterionHasOppositeReasoning = criteria.some(criterion => criterion.opposite_reasoning)

    // Find matching overrule for the selected criterion
    const getExistingOverrule = (criterionIndex) => {
        return overruleReasonings.items.find(
            item => item.criterion_ix === criterionIndex && 
                   item.motif_id === patternId && 
                   item.file_id === fileId
        )
    }

    // Generate modified data with overruled values
    const processedData = criteria.map((criterion, index) => {
        const overrule = getExistingOverrule(index)
        
        return {
            key: index,
            criterion: criterion.criterion,
            reasoning: overrule ? overrule.reasoning : criterion.reasoning,
            met: overrule ? overrule.criterion_met : criterion.is_met,
            oppositeReasoning: overrule ? overrule.opposite_reasoning : criterion.opposite_reasoning,
            flaky: assignment.patterns?.find(pattern => pattern.motif_id === patternId)?.is_flaky,
            // Store original data for reference
            originalMet: criterion.is_met,
            originalReasoning: criterion.reasoning,
            hasOverrule: !!overrule,
            overruleData: overrule
        }
    })

    const columns = [
        {
            title: 'Criterion',
            dataIndex: 'criterion',
            key: 'criterion',
        },
        {
            title: 'Reasoning',
            dataIndex: 'reasoning',
            key: 'reasoning',
            render: (text, record) => (
                <div>
                    {record.hasOverrule && <EditOutlined title='Overruled'/>}{' '}
                    {text}
                </div>
            ),
        },
        ...(someCriterionHasOppositeReasoning
            ? [
                  {
                      title: 'Opposite Reasoning',
                      dataIndex: 'oppositeReasoning',
                      key: 'oppositeReasoning',
                  },
              ]
            : []),
        {
            title: 'Met',
            key: 'met',
            dataIndex: 'met',
            width: '96px',
            render: (result, record) => (
                <MetTag
                    criterion={record}
                    token={token}
                    layerId={layerId}
                    fileId={fileId}
                    patternId={patternId}
                    existingOverrule={record.overruleData}
                />
            ),
        },
        {
            title: 'Flaky',
            key: 'flaky',
            dataIndex: 'flaky',
            width: '96px',
            render: result => (
                <Tag
                    icon={result ? <WarningOutlined /> : <CheckCircleOutlined />}
                    color={result ? 'warning' : 'success'}
                >
                    {result ? 'Flaky' : 'Not Flaky'}
                </Tag>
            ),
        },
    ]

    return (
        <Table 
            columns={columns} 
            dataSource={processedData} 
            pagination={false} 
            loading={loading || isLoadingOverrules} 
            size='small'
        />
    )
}

const mapState = ({ assignment }) => {
    return {
        assignment: assignment.assignment,
    }
}

export default connect(mapState, null)(FileCriteriaReasoningTable)
